import { useSelector } from 'react-redux';

export function useSidebarOpen() {
  const sidebarOpen = useSelector(state => state.admin.ui.sidebarOpen);
  return sidebarOpen;
}
